import { SPI, http, Widget, ViewWidget, DslNodeWidget, ClearCache, useRouter } from '@kunlun/dependencies';
import gql from 'graphql-tag';
import Comp from './MerchantUser.vue';

@SPI.ClassFactory(ViewWidget.Token({ widget: 'merchantUser' }))
export default class MerchantUser extends DslNodeWidget {
  @Widget.Reactive()
  private pamirsPartner: Record<string, unknown> = { name: '' };

  @Widget.Reactive()
  private pamirsPartnerList: Record<string, unknown>[] = [];

  public initialize(props) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  protected async mounted() {
    const url = new URL(location.href);
    const partnerId = url.searchParams.get('partnerId');
    const partnerName = url.searchParams.get('partnerName');

    if (partnerId && partnerName) {
      await this.onLangChange({ id: partnerId, name: partnerName }, false);
      url.searchParams.delete('partnerId');
      url.searchParams.delete('partnerName');
      location.href = url.href;
      return;
    }

    const queryStr = gql`
      mutation {
        ariesMerchantUserPartnerMutation {
          queryCurrentUserPartners(ariesMerchantUserPartner: {}) {
            pamirsPartner {
              id
              name
            }
            pamirsPartnerList {
              id
              name
            }
          }
        }
      }
    `;
    const data = await http.mutate('ariesCoreMerchant', queryStr);
    const queryCurrentUserPartners = data.data?.ariesMerchantUserPartnerMutation?.queryCurrentUserPartners;
    this.pamirsPartnerList = (queryCurrentUserPartners?.pamirsPartnerList || []) as Record<string, unknown>[];
    this.pamirsPartner = queryCurrentUserPartners.pamirsPartner as Record<string, unknown>;

    // 不同浏览器手动刷新
    const partnerId_s = sessionStorage.getItem('CURREN_PARTNER_ID');
    const partnerId_l = localStorage.getItem('CURREN_PARTNER_ID');
    if (partnerId_s !== this.pamirsPartner.id || partnerId_l !== this.pamirsPartner.id) {
      // if (sessionStorage.getItem('CURREN_STATUS') === '2') {
      //   localStorage.removeItem('CURREN_STATUS');
      //   return;
      // };
      location.href = '/';
    }
    sessionStorage.setItem('CURREN_PARTNER_ID', this.pamirsPartner.id as string);
    localStorage.setItem('CURREN_PARTNER_ID', this.pamirsPartner.id as string);

    // 同一浏览器自动刷新
    // window.addEventListener('storage', (e) => {
    //   if (e.key === 'changePartner' && e.newValue === '1') {
    //     location.href = '/';
    //     sessionStorage.setItem('CURREN_STATUS', '2');
    //     localStorage.removeItem('changePartner');
    //   }
    // });
  }

  @Widget.Method()
  private async onLangChange(pamirsPartner: Record<string, unknown>, reloadAfterComplete = true) {
    ClearCache.clear();
    this.pamirsPartner = pamirsPartner;
    const queryStr = gql`mutation {
              ariesMerchantUserPartnerMutation{
                changeCurrentUserPartner(
                  ariesMerchantUserPartner:{
                    pamirsPartner:{
                     id: "${pamirsPartner.id}",
                    name: "${pamirsPartner.name}"
                    }
                  }
                ){
                  pamirsPartner{
                    id
                    name
                  }
                  pamirsPartnerList{
                    id
                    name
                  }
                }
              }
            }
            `;
    const data = await http.mutate('ariesCoreMerchant', queryStr);
    const id = (data.data.ariesMerchantUserPartnerMutation.changeCurrentUserPartner.pamirsPartner as any).id as string;
    sessionStorage.setItem('CURREN_PARTNER_ID', id);
    localStorage.setItem('CURREN_PARTNER_ID', id);
    if (reloadAfterComplete) {
      // 本页刷新
      location.href = '/';
    }
  }
}
